import { Pipe, PipeTransform } from '@angular/core';
import { StageInterface } from '@vendasta/sales-opportunities';
import { Pipeline } from './pipeline-stages/pipeline.model';

@Pipe({
  name: 'selectedPipeline',
})
export class SelectedPipelinePipe implements PipeTransform {
  transform(pipelines: Pipeline[], pipelineId: string): Pipeline {
    return pipelines.find((p) => p.id === pipelineId);
  }
}

@Pipe({
  name: 'pipelineStage',
})
export class PipelineStagePipe implements PipeTransform {
  transform(pipeline: Pipeline, probability: number): StageInterface {
    return pipeline?.findStage(probability);
  }
}
